// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"mca-z","narrowOptionButtons":"nca-z","noOptions":"oca-z"};